// import getConfig from 'next/config';

export const hostname = "https://public-api.freshstatus.io";

export const adminApiHostname = "https://api.freshstatus.io";

export const API_ROOT = "https://public-api.freshstatus.io/v1";
